import { render, staticRenderFns } from "./saleinvoiceimp.vue?vue&type=template&id=682abf38&scoped=true&"
import script from "./saleinvoiceimp.vue?vue&type=script&lang=js&"
export * from "./saleinvoiceimp.vue?vue&type=script&lang=js&"
import style0 from "./saleinvoiceimp.vue?vue&type=style&index=0&id=682abf38&lang=scss&scoped=true&"
import style1 from "./saleinvoiceimp.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682abf38",
  null
  
)

export default component.exports